import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomepageComponent } from '@app/homepage/homepage/homepage.component';
import { SharedModule } from '@app/shared/shared.module';
import { GiftsAdvertisementComponent } from '@app/homepage/gifts-advertisement/gifts-advertisement.component';

@NgModule({
  declarations: [
    HomepageComponent,
    GiftsAdvertisementComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    BrowserAnimationsModule
  ]
})

export class HomepageModule { }
